(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.ContentfulRichText = factory());
}(this, (function () { 'use strict';

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var richTextTypes_es5 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, '__esModule', { value: true });

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var _global = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
  });

  var _core = createCommonjsModule(function (module) {
  var core = module.exports = { version: '2.6.0' };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
  });
  var _core_1 = _core.version;

  var _isObject = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  var _anObject = function (it) {
    if (!_isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };

  var _fails = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };

  // Thank's IE8 for his funny defineProperty
  var _descriptors = !_fails(function () {
    return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
  });

  var document = _global.document;
  // typeof document.createElement is 'object' in old IE
  var is = _isObject(document) && _isObject(document.createElement);
  var _domCreate = function (it) {
    return is ? document.createElement(it) : {};
  };

  var _ie8DomDefine = !_descriptors && !_fails(function () {
    return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
  });

  // 7.1.1 ToPrimitive(input [, PreferredType])

  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  var _toPrimitive = function (it, S) {
    if (!_isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };

  var dP = Object.defineProperty;

  var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    _anObject(O);
    P = _toPrimitive(P, true);
    _anObject(Attributes);
    if (_ie8DomDefine) try {
      return dP(O, P, Attributes);
    } catch (e) { /* empty */ }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };

  var _objectDp = {
  	f: f
  };

  var _propertyDesc = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };

  var _hide = _descriptors ? function (object, key, value) {
    return _objectDp.f(object, key, _propertyDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };

  var hasOwnProperty = {}.hasOwnProperty;
  var _has = function (it, key) {
    return hasOwnProperty.call(it, key);
  };

  var id = 0;
  var px = Math.random();
  var _uid = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };

  var _redefine = createCommonjsModule(function (module) {
  var SRC = _uid('src');
  var TO_STRING = 'toString';
  var $toString = Function[TO_STRING];
  var TPL = ('' + $toString).split(TO_STRING);

  _core.inspectSource = function (it) {
    return $toString.call(it);
  };

  (module.exports = function (O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
    if (O === _global) {
      O[key] = val;
    } else if (!safe) {
      delete O[key];
      _hide(O, key, val);
    } else if (O[key]) {
      O[key] = val;
    } else {
      _hide(O, key, val);
    }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, TO_STRING, function toString() {
    return typeof this == 'function' && this[SRC] || $toString.call(this);
  });
  });

  var _aFunction = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };

  // optional / simple context binding

  var _ctx = function (fn, that, length) {
    _aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 1: return function (a) {
        return fn.call(that, a);
      };
      case 2: return function (a, b) {
        return fn.call(that, a, b);
      };
      case 3: return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
    }
    return function (/* ...args */) {
      return fn.apply(that, arguments);
    };
  };

  var PROTOTYPE = 'prototype';

  var $export = function (type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
    var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
    var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      // export native or passed
      out = (own ? target : source)[key];
      // bind timers to global for call from export context
      exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
      // extend global
      if (target) _redefine(target, key, out, type & $export.U);
      // export
      if (exports[key] != out) _hide(exports, key, exp);
      if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
  };
  _global.core = _core;
  // type bitmap
  $export.F = 1;   // forced
  $export.G = 2;   // global
  $export.S = 4;   // static
  $export.P = 8;   // proto
  $export.B = 16;  // bind
  $export.W = 32;  // wrap
  $export.U = 64;  // safe
  $export.R = 128; // real proto method for `library`
  var _export = $export;

  var toString = {}.toString;

  var _cof = function (it) {
    return toString.call(it).slice(8, -1);
  };

  // fallback for non-array-like ES3 and non-enumerable old V8 strings

  // eslint-disable-next-line no-prototype-builtins
  var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return _cof(it) == 'String' ? it.split('') : Object(it);
  };

  // 7.2.1 RequireObjectCoercible(argument)
  var _defined = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };

  // to indexed object, toObject with fallback for non-array-like ES3 strings


  var _toIobject = function (it) {
    return _iobject(_defined(it));
  };

  // 7.1.4 ToInteger
  var ceil = Math.ceil;
  var floor = Math.floor;
  var _toInteger = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };

  // 7.1.15 ToLength

  var min = Math.min;
  var _toLength = function (it) {
    return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };

  var max = Math.max;
  var min$1 = Math.min;
  var _toAbsoluteIndex = function (index, length) {
    index = _toInteger(index);
    return index < 0 ? max(index + length, 0) : min$1(index, length);
  };

  // false -> Array#indexOf
  // true  -> Array#includes



  var _arrayIncludes = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = _toIobject($this);
      var length = _toLength(O.length);
      var index = _toAbsoluteIndex(fromIndex, length);
      var value;
      // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare
      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare
        if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
      } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      } return !IS_INCLUDES && -1;
    };
  };

  var _shared = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global[SHARED] || (_global[SHARED] = {});

  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core.version,
    mode:  'global',
    copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
  });
  });

  var shared = _shared('keys');

  var _sharedKey = function (key) {
    return shared[key] || (shared[key] = _uid(key));
  };

  var arrayIndexOf = _arrayIncludes(false);
  var IE_PROTO = _sharedKey('IE_PROTO');

  var _objectKeysInternal = function (object, names) {
    var O = _toIobject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i) if (_has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };

  // IE 8- don't enum bug keys
  var _enumBugKeys = (
    'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
  ).split(',');

  // 19.1.2.14 / 15.2.3.14 Object.keys(O)



  var _objectKeys = Object.keys || function keys(O) {
    return _objectKeysInternal(O, _enumBugKeys);
  };

  var f$1 = {}.propertyIsEnumerable;

  var _objectPie = {
  	f: f$1
  };

  var isEnum = _objectPie.f;
  var _objectToArray = function (isEntries) {
    return function (it) {
      var O = _toIobject(it);
      var keys = _objectKeys(O);
      var length = keys.length;
      var i = 0;
      var result = [];
      var key;
      while (length > i) if (isEnum.call(O, key = keys[i++])) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      } return result;
    };
  };

  // https://github.com/tc39/proposal-object-values-entries

  var $values = _objectToArray(false);

  _export(_export.S, 'Object', {
    values: function values(it) {
      return $values(it);
    }
  });

  var values = _core.Object.values;

  var _wks = createCommonjsModule(function (module) {
  var store = _shared('wks');

  var Symbol = _global.Symbol;
  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] =
      USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
  };

  $exports.store = store;
  });

  // 22.1.3.31 Array.prototype[@@unscopables]
  var UNSCOPABLES = _wks('unscopables');
  var ArrayProto = Array.prototype;
  if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
  var _addToUnscopables = function (key) {
    ArrayProto[UNSCOPABLES][key] = true;
  };

  // https://github.com/tc39/Array.prototype.includes

  var $includes = _arrayIncludes(true);

  _export(_export.P, 'Array', {
    includes: function includes(el /* , fromIndex = 0 */) {
      return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  _addToUnscopables('includes');

  var includes = _core.Array.includes;

  /**
   * Map of all Contentful block types. Blocks contain inline or block nodes.
   */
  var BLOCKS;
  (function (BLOCKS) {
      BLOCKS["DOCUMENT"] = "document";
      BLOCKS["PARAGRAPH"] = "paragraph";
      BLOCKS["HEADING_1"] = "heading-1";
      BLOCKS["HEADING_2"] = "heading-2";
      BLOCKS["HEADING_3"] = "heading-3";
      BLOCKS["HEADING_4"] = "heading-4";
      BLOCKS["HEADING_5"] = "heading-5";
      BLOCKS["HEADING_6"] = "heading-6";
      BLOCKS["OL_LIST"] = "ordered-list";
      BLOCKS["UL_LIST"] = "unordered-list";
      BLOCKS["LIST_ITEM"] = "list-item";
      BLOCKS["HR"] = "hr";
      BLOCKS["QUOTE"] = "blockquote";
      BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
      BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
  })(BLOCKS || (BLOCKS = {}));
  var BLOCKS$1 = BLOCKS;

  /**
   * Map of all Contentful inline types. Inline contain inline or text nodes.
   */
  var INLINES;
  (function (INLINES) {
      INLINES["HYPERLINK"] = "hyperlink";
      INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
      INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
      INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
  })(INLINES || (INLINES = {}));
  var INLINES$1 = INLINES;

  /**
   * Map of all Contentful marks.
   */
  var marks = {
      BOLD: 'bold',
      ITALIC: 'italic',
      UNDERLINE: 'underline',
      CODE: 'code',
  };

  var _a;
  /**
   * Array of all top level block types.
   * Only these block types can be the direct children of the document.
   */
  var TOP_LEVEL_BLOCKS = [
      BLOCKS$1.PARAGRAPH,
      BLOCKS$1.HEADING_1,
      BLOCKS$1.HEADING_2,
      BLOCKS$1.HEADING_3,
      BLOCKS$1.HEADING_4,
      BLOCKS$1.HEADING_5,
      BLOCKS$1.HEADING_6,
      BLOCKS$1.OL_LIST,
      BLOCKS$1.UL_LIST,
      BLOCKS$1.HR,
      BLOCKS$1.QUOTE,
      BLOCKS$1.EMBEDDED_ENTRY,
      BLOCKS$1.EMBEDDED_ASSET,
  ];
  /**
   * Array of all void block types
   */
  var VOID_BLOCKS = [BLOCKS$1.HR, BLOCKS$1.EMBEDDED_ENTRY, BLOCKS$1.EMBEDDED_ASSET];
  /**
   * Dictionary of all container block types, and the set block types they accept as children.
   */
  var CONTAINERS = (_a = {},
      _a[BLOCKS$1.OL_LIST] = [BLOCKS$1.LIST_ITEM],
      _a[BLOCKS$1.UL_LIST] = [BLOCKS$1.LIST_ITEM],
      _a[BLOCKS$1.LIST_ITEM] = TOP_LEVEL_BLOCKS.slice(),
      _a[BLOCKS$1.QUOTE] = [BLOCKS$1.PARAGRAPH],
      _a);

  /**
   * Checks if the node is an instance of Inline.
   */
  function isInline(node) {
      return Object.values(INLINES$1).includes(node.nodeType);
  }
  /**
   * Checks if the node is an instance of Block.
   */
  function isBlock(node) {
      return Object.values(BLOCKS$1).includes(node.nodeType);
  }
  /**
   * Checks if the node is an instance of Text.
   */
  function isText(node) {
      return node.nodeType === 'text';
  }

  var helpers = /*#__PURE__*/Object.freeze({
  	isInline: isInline,
  	isBlock: isBlock,
  	isText: isText
  });

  exports.helpers = helpers;
  exports.BLOCKS = BLOCKS$1;
  exports.INLINES = INLINES$1;
  exports.MARKS = marks;
  exports.TOP_LEVEL_BLOCKS = TOP_LEVEL_BLOCKS;
  exports.VOID_BLOCKS = VOID_BLOCKS;
  exports.CONTAINERS = CONTAINERS;

  });

  unwrapExports(richTextTypes_es5);
  var richTextTypes_es5_1 = richTextTypes_es5.helpers;
  var richTextTypes_es5_2 = richTextTypes_es5.BLOCKS;
  var richTextTypes_es5_3 = richTextTypes_es5.INLINES;
  var richTextTypes_es5_4 = richTextTypes_es5.MARKS;
  var richTextTypes_es5_5 = richTextTypes_es5.TOP_LEVEL_BLOCKS;
  var richTextTypes_es5_6 = richTextTypes_es5.VOID_BLOCKS;
  var richTextTypes_es5_7 = richTextTypes_es5.CONTAINERS;

  var _defaultMarkRenderers, _defaultNodeRenderers;

  var defaultInline = function defaultInline(type, node, key, h) {
    return h('span', {
      key: key,
      style: {
        margin: "0px 5px",
        padding: "0 .25rem 0 .75rem",
        border: "1px solid #d3dce0",
        fontFamily: "monospace"
      }
    }, "inline: ".concat(type, ", sys.id: ").concat(node.data.target.sys.id));
  };

  var defaultMarkRenderers = (_defaultMarkRenderers = {}, _defineProperty(_defaultMarkRenderers, richTextTypes_es5_4.BOLD, function (children, key, h) {
    return h('strong', {
      key: key
    }, children);
  }), _defineProperty(_defaultMarkRenderers, richTextTypes_es5_4.ITALIC, function (children, key, h) {
    return h('em', {
      key: key
    }, children);
  }), _defineProperty(_defaultMarkRenderers, richTextTypes_es5_4.UNDERLINE, function (children, key, h) {
    return h('u', {
      key: key
    }, children);
  }), _defineProperty(_defaultMarkRenderers, richTextTypes_es5_4.CODE, function (children, key, h) {
    return h('code', {
      key: key
    }, children);
  }), _defaultMarkRenderers);
  var defaultNodeRenderers = (_defaultNodeRenderers = {}, _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.PARAGRAPH, function (node, key, h, next) {
    return h('p', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.HEADING_1, function (node, key, h, next) {
    return h('h1', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.HEADING_2, function (node, key, h, next) {
    return h('h2', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.HEADING_3, function (node, key, h, next) {
    return h('h3', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.HEADING_4, function (node, key, h, next) {
    return h('h4', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.HEADING_5, function (node, key, h, next) {
    return h('h5', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.HEADING_6, function (node, key, h, next) {
    return h('h6', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.EMBEDDED_ENTRY, function (node, key, h, next) {
    return h('div', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.UL_LIST, function (node, key, h, next) {
    return h('ul', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.OL_LIST, function (node, key, h, next) {
    return h('ol', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.LIST_ITEM, function (node, key, h, next) {
    return h('li', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.QUOTE, function (node, key, h, next) {
    return h('blockquote', {
      key: key
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_2.HR, function (_node, key, h) {
    return h('hr', {
      key: key
    }, {});
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_3.ASSET_HYPERLINK, function (node, key, h) {
    return defaultInline(richTextTypes_es5_3.ASSET_HYPERLINK, node, key, h);
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_3.ENTRY_HYPERLINK, function (node, key, h) {
    return defaultInline(richTextTypes_es5_3.ENTRY_HYPERLINK, node, key, h);
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_3.EMBEDDED_ENTRY, function (node, key, h) {
    return defaultInline(richTextTypes_es5_3.EMBEDDED_ENTRY, node, key, h);
  }), _defineProperty(_defaultNodeRenderers, richTextTypes_es5_3.HYPERLINK, function (node, key, h, next) {
    return h('a', {
      key: key,
      attrs: {
        href: node.data.uri
      }
    }, next(node.content, key, h, next));
  }), _defineProperty(_defaultNodeRenderers, "text", function text(_ref, key, h, markRenderer) {
    var marks = _ref.marks,
        value = _ref.value;

    if (!marks.length) {
      return value;
    }

    var marksReversed = _toConsumableArray(marks).reverse();

    return marksReversed.reduce(function (aggregate, mark, i) {
      return markRenderer[mark.type]([aggregate], "".concat(key, "-").concat(i), h);
    }, value);
  }), _defaultNodeRenderers);

  var renderNodeList = function renderNodeList(nodes, key, renderer) {
    return nodes.map(function (node, i) {
      return renderNode(node, "".concat(key, "-").concat(i), renderer);
    });
  };

  var renderNode = function renderNode(node, key, renderer) {
    var nodeRenderer = renderer.node;
    var createElement = renderer.createElement;

    if (richTextTypes_es5_1.isText(node)) {
      // We're at final tip of node branch, can render text.
      var markerRender = renderer.mark;
      return nodeRenderer.text(node, key, createElement, markerRender);
    } else {
      var nextNode = function nextNode(nodes) {
        return renderNodeList(nodes, key, renderer);
      };

      if (!nodeRenderer) {
        return createElement('div', "".concat(key, " ;lost nodeRenderer"));
      }

      if (!node.nodeType || !nodeRenderer[node.nodeType]) {
        // TODO: Figure what to return when passed an unrecognized node.
        return "(Unrecognized node type) " + (node.nodeType || "empty");
      }

      return nodeRenderer[node.nodeType](node, key, createElement, nextNode);
    }
  };

  var index = {
    functional: true,
    props: ["document", "nodeRenderers", "markRenderers"],
    render: function render(h, ctx) {
      var renderer = {
        node: _objectSpread2({}, defaultNodeRenderers, {}, ctx.props.nodeRenderers),
        mark: _objectSpread2({}, defaultMarkRenderers, {}, ctx.props.markRenderers),
        createElement: h
      };
      return renderNodeList(ctx.props.document.content, "RichText-", renderer);
    }
  };

  return index;

})));
